import { Component, Input, OnInit } from '@angular/core';
import { Food } from '../../../../domains/food';
import { Tag } from '../../../../domains/tag';
import { NotificationService } from '../../../../services/notification.service';

@Component({
  selector: 'app-mobile-allergen-modal',
  templateUrl: './mobile-allergen-modal.component.html',
  styleUrls: [
  ]
})
export class MobileAllergenModalComponent implements OnInit {
  @Input() food: Food;
  @Input() allergens: Tag[];

  constructor(
    private notificationService: NotificationService
  ) {

  }

  ngOnInit(): void {
  }

  disclaimerClick() {
    this.notificationService.onAllergensClicked();
  }
}
